import React from 'react'
import PropTypes from 'prop-types'
import CmsModules from '../../../leap/modules'
import {Chakra3Theme} from '../../../leap/theme'

const PdpCmsModules = ({assetId, theme = 'light', hideInConfiguratorSidebar = false}) => (
    <Chakra3Theme theme={theme}>
        <CmsModules assetId={assetId} hideInConfiguratorSidebar={hideInConfiguratorSidebar} />
    </Chakra3Theme>
)

PdpCmsModules.propTypes = {
    assetId: PropTypes.string,
    theme: PropTypes.oneOf(['light', 'dark']),
    hideInConfiguratorSidebar: PropTypes.bool
}

export default PdpCmsModules
